
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Nonacbusserviceinpune() {



    const cardData =
    {
        keyword: 'Non Ac Bus Rental Service in Pune',
        heading: 'Amruta Travels: Non Ac Bus Rental Service in Pune',
        headingDescription: 'Amruta Travels offers Non-AC Bus Rental Service in Pune, providing a budget-friendly and comfortable transportation solution for various group travel needs. Whether you are planning a school trip, corporate outing, wedding, or a family picnic, our fleet of well-maintained non-AC buses ensures a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make group travel simple and stress-free. Choose from our range of non-AC buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your Non-AC Bus with Amruta Travels and travel together in comfort and affordability!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

       "services": [
    {
      "name": "Non AC Bus for Hire for Outstation",
      "description": "Amruta Travels offers affordable Non-AC buses for outstation trips from Pune. Ideal for budget-conscious group travel, our buses are spacious, well-maintained, and operated by experienced drivers—perfect for school trips, temple tours, or family outings."
    },
    {
      "name": "Non AC Tempo Traveller on Rent Pune",
      "description": "Looking for a cost-effective group travel option? Amruta Travels provides Non-AC Tempo Travellers on rent in Pune. Ideal for short-distance travel or group shuttles, these vehicles combine comfort, safety, and affordability for up to 17 passengers."
    },
    {
      "name": "Non AC Bus Hire on Rent in Pune",
      "description": "Get reliable Non-AC buses on rent in Pune with Amruta Travels. Whether you're planning a school trip, pilgrimage, or day outing, our buses offer a comfortable ride, reasonable pricing, and punctual service tailored for group journeys."
    },
    {
      "name": "Non AC Mini Bus Hire on Rent in Pune",
      "description": "Amruta Travels provides Non-AC mini bus rental services in Pune. Suitable for 14 to 25 passengers, these mini buses are perfect for small groups looking for a budget-friendly travel solution for weddings, field trips, or short-distance outings."
    },
    {
      "name": "Non AC Bus Hire for Picnic in Pune",
      "description": "Planning a picnic in or around Pune? Amruta Travels offers Non-AC buses for hire that are spacious and economical—perfect for schools, colleges, and local organizations looking for reliable transportation without high costs."
    },
    {
      "name": "Best Bus Rental Service in Pune",
      "description": "Amruta Travels is one of the most trusted names for bus rental services in Pune. From AC to Non-AC, mini to large seater buses, we offer punctual, clean, and customer-focused travel solutions for corporate events, weddings, school trips, and more."
    },
    {
      "name": "32, 35, 40, 45 Seater Local and Outstation Bus",
      "description": "Choose from our fleet of 32, 35, 40, and 45-seater buses for local or outstation use. Amruta Travels offers both AC and Non-AC options with professional drivers, comfortable seating, and customizable travel plans to suit your group size and purpose."
    },
    {
      "name": "14, 17, 20, 25 Seater Bus on Rent Pune",
      "description": "Amruta Travels offers smaller group travel options with 14, 17, 20, and 25-seater buses on rent in Pune. Whether it's for a family function, office trip, or school outing, we provide both AC and Non-AC variants with clean, well-kept vehicles."
    }
  ],
  "tableData": [
    ["Non AC Bus for Hire for Outstation", "Non AC Tempo Traveller on Rent Pune"],
    ["Non AC Bus Hire on Rent in Pune", "Non AC Mini Bus Hire on Rent in Pune"],
    ["Non AC Bus Hire for Picnic in Pune", "Best Bus Rental Service in Pune"],
    ["32, 35, 40, 45 Seater Local and Outstation Bus", "14, 17, 20, 25 Seater Bus on Rent Pune"]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Affordable Group Travel Solution",
    "WhyChoosedescription": "Amruta Travels offers Non AC Bus Rental Service in Pune, ideal for budget-friendly group transportation. Enjoy reliable travel without compromising on comfort or service quality."
  },
  {
    "WhyChooseheading": "Perfect for Local and Short-Distance Travel",
    "WhyChoosedescription": "Our non-AC buses are best suited for school trips, weddings, day picnics, and local sightseeing within Pune and nearby areas, providing economical yet convenient travel options."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Seating",
    "WhyChoosedescription": "All our non-AC buses are designed with ample legroom, wide seats, and proper ventilation to ensure a comfortable journey even without air conditioning."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe Rides",
    "WhyChoosedescription": "Our drivers are trained, professional, and well-acquainted with Pune’s routes, ensuring a safe and hassle-free experience from start to finish."
  },
  {
    "WhyChooseheading": "Transparent and Budget-Friendly Pricing",
    "WhyChoosedescription": "We offer clear and competitive rates for Non AC Bus Rental Service in Pune. No hidden costs—just honest pricing that fits your group travel budget."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Fleet",
    "WhyChoosedescription": "Our non-AC buses are regularly cleaned and well-maintained, ensuring hygiene and reliability for all types of travel requirements."
  },
  {
    "WhyChooseheading": "Multiple Seating Capacities Available",
    "WhyChoosedescription": "Choose from various non-AC bus sizes like 17-seater, 32-seater, or 50-seater to match your group size. We provide the right vehicle for every occasion."
  },
  {
    "WhyChooseheading": "Easy Booking and Customer Support",
    "WhyChoosedescription": "Booking a Non AC Bus with Amruta Travels is simple and quick. Our customer support team is always ready to assist with scheduling, planning, and other travel needs."
  }
]






























    }

const faqData = [
  {
    question: 'How can I rent a Non AC bus in Pune with Amruta Travels?',
    answer: 'You can rent a Non AC bus in Pune easily with Amruta Travels by booking online, calling our support team, or visiting our office. We’ll help you select the right Non AC bus based on your group size and travel plan.',
  },
  {
    question: 'What types of Non AC buses are available for rent?',
    answer: 'We offer a variety of Non AC buses, including 32, 35, 45, and 50 seater options. These buses are ideal for budget-friendly travel for schools, events, religious trips, and local/outstation tours.',
  },
  {
    question: 'Are Non AC buses suitable for school trips and budget group travel?',
    answer: 'Yes, Non AC buses are a popular choice for school trips, college outings, and large group travels where cost-effective transport is needed. They provide comfortable seating and ample space.',
  },
  {
    question: 'Are the Non AC buses clean and well-maintained?',
    answer: 'Absolutely. All our Non AC buses are regularly maintained and cleaned thoroughly before every trip. We prioritize hygiene and comfort for all our passengers.',
  },
  {
    question: 'Do you provide drivers with Non AC bus rentals?',
    answer: 'Yes, all our Non AC bus rentals include a professional and experienced driver to ensure safe and punctual travel.',
  },
  {
    question: 'Can I book Non AC buses for both local and outstation use?',
    answer: 'Yes, our Non AC buses are available for both local city use and outstation travel. Whether it’s a day trip or multi-day journey, we ensure a smooth experience.',
  },
  {
    question: 'What is the cost of renting a Non AC bus in Pune?',
    answer: 'The cost depends on the seating capacity, trip duration, and distance. Contact us with your travel details and we’ll provide a transparent and budget-friendly quote.',
  },
  {
    question: 'Can we request multiple pickup and drop-off points?',
    answer: 'Yes, we offer flexible routing. Just share your pickup and drop-off locations in advance, and we’ll plan accordingly to accommodate your group.',
  },
  {
    question: 'Why choose Amruta Travels for Non AC bus rental in Pune?',
    answer: 'Amruta Travels offers affordable and dependable Non AC bus rentals with professional drivers and a customer-first approach. We focus on comfort, punctuality, and overall satisfaction.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Deepak Shinde',
    role: 'School Principal, Pune',
    text: 'We booked a 50-seater Non AC bus from Amruta Travels for a school picnic. The bus was clean and well-maintained, and the driver was very cooperative. Excellent budget option for large groups.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Meenal Rane',
    role: 'Event Organizer, Pune',
    text: 'For a local religious trip, we chose a Non AC bus from Amruta Travels. It was comfortable and economical. The service was punctual and professional throughout.',
    rating: 5,
  },
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Non AC Bus Rental Service in Pune",
  "image": "https://bushireinpune.com/assets/images/non-ac-bus-rental-service-pune.jpg",
  "description": "Rent Non-AC buses for outstation trips, picnics, and more in Pune. Choose from 14, 17, 20, 25, 32, 35, 40, and 45-seater buses for affordable travel with Amruta Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4950"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "30", // Adjust based on per km or flat rate for non-AC bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/non-ac-bus-rental-service-in-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Non AC Bus Rental Service in Pune | Affordable Non-AC Bus Hire | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent Non-AC buses in Pune for outstation trips, picnics, and more. Choose from various seating capacities from 14 to 45 seats with Amruta Travels for a cost-effective and comfortable journey." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Nonacbusserviceinpune;